export enum TextBreak {
  header = 'header',
  content = 'content',
  both = 'both',
  none = 'none'
}
